export default "__VITE_ASSET__RCzLbCuC__"